"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _styles = require("@material-ui/core/styles");

var _ImageBase = _interopRequireDefault(require("./ImageBase"));

var _ImageFiltersOptions = _interopRequireDefault(require("./ImageFiltersOptions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  preview: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    marginBottom: theme.spacing(14)
  },
  footer: {
    position: "absolute",
    top: "auto",
    right: 0,
    left: 0,
    bottom: 0,
    paddingTop: theme.spacing(2),
    height: theme.spacing(14)
  }
}));

const EditImageFilters = (_ref) => {
  let className = _ref.className,
      imageUrl = _ref.imageUrl,
      _ref$imageCropdata = _ref.imageCropdata,
      imageCropdata = _ref$imageCropdata === void 0 ? {} : _ref$imageCropdata,
      _ref$imageFilters = _ref.imageFilters,
      imageFilters = _ref$imageFilters === void 0 ? {} : _ref$imageFilters,
      style = _ref.style,
      _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? [] : _ref$menu,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["className", "imageUrl", "imageCropdata", "imageFilters", "style", "menu", "onChange"]);

  const classes = useStyles();

  const handleChange = imageFilters => {
    onChange && onChange(imageFilters);
  };

  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement("div", {
    className: classes.preview
  }, _react.default.createElement(_ImageBase.default, {
    imageCropdata: imageCropdata,
    imageFilters: imageFilters,
    imageUrl: imageUrl
  })), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_ImageFiltersOptions.default, {
    imageUrl: imageUrl,
    imageFilters: imageFilters,
    onChange: handleChange
  })));
};

var _default = EditImageFilters;
exports.default = _default;
module.exports = exports.default;